class CrossOriginDownload extends HTMLElement {
  connectedCallback(): void {
    this.querySelectorAll<HTMLAnchorElement>('a[download]').forEach((link) => {
      link.addEventListener('click', this.handleClick);
    });
  }

  handleClick = (e: Event): void => {
    e.preventDefault();
    const link = e.currentTarget as HTMLAnchorElement;
    const url = link.href;
    const filename = url.split('/').pop()?.split('?')[0] || 'download';

    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);
      })
      .catch(() => {
        window.open(url, '_blank');
      });
  };

  disconnectedCallback(): void {
    this.querySelectorAll<HTMLAnchorElement>('a[download]').forEach((link) => {
      link.removeEventListener('click', this.handleClick);
    });
  }
}

export default CrossOriginDownload;
